import { Avatar, Box, Button, Chip, Stack, Typography } from '@mui/material'
import male from '../../../../Assets/Images/male.png'
import female from '../../../../Assets/Images/female.png'
import { tsAnimal } from '../../../../Typescript/DB_Interface'
import { getCodeSetLabelFromList } from '../../../../Functions/CodeSetFns'
import { useSampleContext } from '../../../../Contexts/Modules/SampleModule/SampleModule'
import AnimalDetailsInModal from '../../../Animal/AnimalDetailsInModal'
import { useState } from 'react'

function AnimalButton({ animal }: { animal: Partial<tsAnimal> }) {
  const { statusCodesQuery } = useSampleContext()
  const fontSize = 14
  const genderIconSize = '50px'
  const [UAI, setUAI] = useState('')
  return (
    <>
      <AnimalDetailsInModal
        setUAI={setUAI}
        UAI={UAI}
      />
      <Button
        fullWidth
        variant="outlined"
        onClick={() => setUAI(animal.UAI ? animal.UAI.toString() : '')}
        tabIndex={-1}
        key={animal.UAI}
        sx={{
          width: 1,
          display: 'flex',
          textTransform: 'none',
          alignItems: 'center',
          color: 'primary.heading',
        }}
      >
        <Stack
          direction={'row'}
          gap={3}
          width={1}
          alignItems={'center'}
        >
          <Chip
            variant={'outlined'}
            avatar={
              animal.Sex === 'M' ?
                <img
                  style={{ width: genderIconSize, height: genderIconSize }}
                  src={male}
                  alt="male"
                  aria-label={'male'}
                />
              : <img
                  style={{ width: genderIconSize, height: genderIconSize }}
                  src={female}
                  alt="female"
                  aria-label={'female'}
                />
            }
            label={animal.AnimalID}
          />
          <Stack gap={1 / 2}>
            <Box sx={{ display: 'flex', width: 1 }}>
              <Typography sx={{ fontWeight: 'bold', fontSize }}>
                Line Name:&nbsp;
              </Typography>
              <Typography sx={{ fontSize }}>{animal.ShortLineName}</Typography>
            </Box>
            <Box sx={{ display: 'flex', width: 1 }}>
              <Typography sx={{ fontWeight: 'bold', fontSize }}>
                Status:&nbsp;
              </Typography>
              <Typography sx={{ fontSize }}>
                {getCodeSetLabelFromList(statusCodesQuery.data, animal.Status)}
              </Typography>
            </Box>
          </Stack>
          <Chip
            sx={{ ml: 'auto' }}
            avatar={<Avatar>{animal.SamplesTaken}</Avatar>}
            label="Previously Collected"
            variant={'outlined'}
          />
        </Stack>
      </Button>
    </>
  )
}

export default AnimalButton
